<div class="header-wrapper">
    <div class="container">
        <div id="header" class="header-bar">

            <button class="hamburger-menu d-lg-none" (click)="toggleMobileMenu()" type="button" aria-label="Menú">
                <span></span>
                <span></span>
                <span></span>
            </button>

            <a [routerLink]="['/ciudadano']" class="logo-link">
                <app-brand-mark height="40"></app-brand-mark>
            </a>

            <nav class="main-nav d-none d-lg-flex" aria-label="Secciones del portal">
                <a
                    *ngFor="let item of navItems"
                    class="nav-link-item"
                    [routerLink]="item.link"
                    [queryParams]="item.queryParams"
                    [class.nav-active]="isNavActive(item)">
                    {{ item.label }}
                </a>
            </nav>

            <div class="header-actions">
                <ul *ngIf="currentUser" class="d-none d-lg-flex align-items-center nav-menus mb-0 pl-0">
                    <li (click)="toggleDropdown()" class="user-menu-item">
                        <div class="d-flex align-items-center user-pill">
                            <span class="user-initials">{{ currentUser.initials }}</span>
                            <span class="user-display-name ml-2">{{ currentUser.displayName }}</span>
                            <i class="fa fa-chevron-down ml-2 chevron-icon"></i>
                        </div>
                        <ul *ngIf="isOpen" class="profile-dropdown bg-white">
                            <li>
                                <a *ngIf="currentUser?.roles !== 'admin'"
                                   [routerLink]="['/ciudadano/profile/', currentUser?.id]"
                                   class="dropdown-item-link">
                                    Ver perfil
                                </a>
                            </li>
                            <li class="dropdown-divider-line"></li>
                            <li (click)="logout()" class="dropdown-item-link logout-link">
                                Cerrar sesión
                            </li>
                        </ul>
                    </li>
                </ul>

                <a *ngIf="!currentUser" routerLink="/ciudadano/iniciar-sesion" class="btn-acceso d-none d-lg-inline-flex">
                    Iniciar sesión
                </a>

                <a *ngIf="currentUser" [routerLink]="['/ciudadano/profile/', currentUser?.id]"
                   class="d-lg-none mobile-user-icon">
                    <span class="user-initials user-initials-sm">{{ currentUser.initials }}</span>
                </a>
            </div>

        </div>
    </div>
</div>

<div class="mobile-menu-overlay" [class.active]="isMobileMenuOpen" (click)="closeMobileMenu()"></div>

<div class="mobile-menu" [class.active]="isMobileMenuOpen">
    <div class="mobile-menu-header">
        <app-brand-mark height="36"></app-brand-mark>
        <button class="mobile-close-btn" (click)="closeMobileMenu()" type="button" aria-label="Cerrar menú">
            <i class="fa fa-times"></i>
        </button>
    </div>
    <div class="mobile-menu-content">
        <ul class="mobile-nav-list">
            <li *ngFor="let item of navItems">
                <a
                    [routerLink]="item.link"
                    [queryParams]="item.queryParams"
                    [class.mobile-nav-active]="isNavActive(item)"
                    (click)="closeMobileMenu()">
                    {{ item.label }}
                </a>
            </li>
        </ul>

        <div class="mobile-menu-footer">
            <ng-container *ngIf="currentUser">
                <div class="mobile-user-info">
                    <div class="user-initials user-initials-lg">{{ currentUser.initials }}</div>
                    <span class="mobile-user-name">{{ currentUser.displayName }}</span>
                </div>
                <a *ngIf="currentUser?.roles !== 'admin'"
                   [routerLink]="['/ciudadano/profile/', currentUser?.id]"
                   (click)="closeMobileMenu()" class="mobile-btn mobile-btn-outline">
                    Ver perfil
                </a>
                <a (click)="logout(); closeMobileMenu()" class="mobile-btn mobile-btn-danger">
                    Cerrar sesión
                </a>
            </ng-container>
            <ng-container *ngIf="!currentUser">
                <a routerLink="/ciudadano/iniciar-sesion" (click)="closeMobileMenu()"
                   class="mobile-btn mobile-btn-primary">
                    Iniciar sesión
                </a>
            </ng-container>
        </div>
    </div>
</div>
